var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-card",style:({
    width: _vm.size == 'small' ? '90px' : '140px',
    height: _vm.size == 'small' ? '64px' : '102px',
    padding: _vm.size == 'small' ? '10px 0 10px 14px' : '18px 0 17px 14px',
    background: _vm.background
  })},[_c('div',{staticClass:"activity-card-title",style:({ 'font-size': _vm.size == 'small' ? '12px' : '14px' })},[_vm._v(" "+_vm._s(_vm.title)),(_vm.code)?_c('AftTooltip',{staticStyle:{"top":"0px","left":"4px"},attrs:{"code":_vm.code}}):_vm._e()],1),_c('div',{staticClass:"activity-card-number",style:({ 'font-size': _vm.size == 'small' ? '18px' : '24px' })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }